//#region Util Imports

import * as $ from 'jquery'

//#endregion

//#region Helper Imports

import { Dictionary } from '../../helpers/dictionary'
import { DataProvider } from '../../helpers/data-provider'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable, ICopyable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDescr } from './op-descr'
import { OpModule } from './op-module'
import { Utils } from '../util/utils'

export class OpRole implements IReferenceType, IOpChangeState, IJsonSerializable, ICopyable<OpRole> {

    //#region Properties

    public idDescr: number
    public idModule: number
    public idRole: number
    public name: string

    //#endregion


    //#region NavigationProperties

    private _descr: OpDescr
    public get descr(): OpDescr {
        return this._descr
    }
    public set descr(value: OpDescr) {
        this._descr = value
        this.idDescr = value != null ? value.idDescr : null
    }

    private _module: OpModule
    public get module(): OpModule {
        return this._module
    }
    public set module(value: OpModule) {
        this._module = value
        this.idModule = value != null ? value.idModule : null
    }

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpRole) {
            this.copy(<OpRole>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState

    //#endregion


    //#region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdRole
    }

    public getReferenceKey(): number {
        return this.idRole
    }

    public getReferenceValue(): any {
        return this
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || Utils.isJSONCompressed(opObj)) {
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.module = opObj.M ? new OpModule(opObj.M) : null
                this.idRole = opObj.IR
                this.idModule = opObj.IM
                this.name = opObj.N
                this.idDescr = opObj.ID
                this.opState = opObj.O
            } else {
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.module = opObj._Module ? new OpModule(opObj._Module) : null
                this.idRole = opObj.ID_ROLE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.idModule = opObj.ID_MODULE
                this.opState = opObj.OpState
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result = {
                IR: this.idRole,
                N: this.name,
                ID: this.idDescr,
                IM: this.idModule,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                M: this.module != null ? this.module.toJSON(compressed) : null,
                O: this.opState,
            }

            Utils.setJSONCompressedFlag(result)

            return result
        }

        return {
            ID_ROLE: this.idRole,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            ID_MODULE: this.idModule,
            _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
            _Module: this.module != null ? this.module.toJSON(compressed) : null,
            OpState: this.opState
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpRole {
        const newRole = new OpRole(null)

        newRole.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newRole
    }

    public copy(source: OpRole, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            if (source.descr != null) {
                this.descr = source.descr
            }

            if (source.module != null) {
                this.module = source.module
            }
        }

        // No custom properties
        // No datalist
        // No dynamicValues

        this.idRole = source.idRole
        this.name = source.name
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    //#endregion


    //#region ToString

    public toString() {
        if (this.descr) {
            return this.descr.toString()
        }

        return this.name
    }

    //#endregion


    //#region LoadNavigationProperties

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpRole[]): JQueryPromise<OpRole[]> {
        const defered: JQueryDeferred<OpRole[]> = $.Deferred<OpRole[]>()

        if (dataProvider != null && list != null && list.length > 0) {
            dataProvider.System
                .getDictionaries([Enums.ReferenceType.IdModule])
                .then((dict: Dictionary<Dictionary<IReferenceType>>) => {
                    let moduleDict: Dictionary<OpModule> = new Dictionary<OpModule>(null)

                    if (dict.containsKey(Enums.ReferenceType.IdModule)) {
                        moduleDict = <Dictionary<OpModule>>dict.tryGetValue(Enums.ReferenceType.IdModule)
                    }

                    list.forEach((item: OpRole) => {
                        item.module = moduleDict.tryGetTypedValue<OpModule>(item.idModule)
                    })

                    defered.resolve(list)
                })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    //#endregion
}